// Minimal, safe inline formatting for CMS text: **bold**, *italic* and
// [link text](https://… or /path). No raw HTML is ever rendered.
// Paragraph blocks: blank-line separated paragraphs; lines starting with
// "- " group into bullet lists.
import { Link } from 'react-router-dom';

const TOKEN_RE = /(\*\*[^*]+\*\*|\*[^*\n]+\*|\[[^\]]+\]\((?:https?:\/\/[^\s)]+|\/[^\s)]*)\))/g;

const renderInline = (text) =>
  String(text ?? '').split(TOKEN_RE).map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return <strong key={i} className="font-bold text-navy-900">{part.slice(2, -2)}</strong>;
    }
    if (part.startsWith('*') && part.endsWith('*') && part.length > 2) {
      return <em key={i}>{part.slice(1, -1)}</em>;
    }
    const link = part.match(/^\[([^\]]+)\]\((.+)\)$/);
    if (link) {
      const [, label, href] = link;
      if (href.startsWith('/')) {
        return <Link key={i} to={href} className="font-semibold text-navy-900 underline underline-offset-2 hover:text-gold-700">{label}</Link>;
      }
      return <a key={i} href={href} target="_blank" rel="noopener noreferrer" className="font-semibold text-navy-900 underline underline-offset-2 hover:text-gold-700">{label}</a>;
    }
    return part;
  });

// Inline formatting for a single string (paragraphs, headings, list items).
export const InlineText = ({ text }) => <>{renderInline(text)}</>;

// Multi-paragraph text with optional "- " bullet lists.
export const MarkdownBlock = ({ text, className = '', testid }) => {
  const blocks = String(text ?? '').split(/\n{2,}/).map((b) => b.trim()).filter(Boolean);
  return (
    <div className={className} data-testid={testid}>
      {blocks.map((block, i) => {
        const lines = block.split('\n');
        if (lines.every((l) => l.trim().startsWith('- '))) {
          return (
            <ul key={i} className="list-disc space-y-1.5 pl-5 marker:text-gold-600">
              {lines.map((l, j) => (
                <li key={j}><InlineText text={l.trim().slice(2)} /></li>
              ))}
            </ul>
          );
        }
        return <p key={i} className={i > 0 ? 'mt-4' : ''}><InlineText text={block} /></p>;
      })}
    </div>
  );
};
